module.exports = __webpack_public_path__ + "img/psd.ba87fb06.png";